

<template>
	<div class="assessment-container">
		<a-spin :spinning="loading">
			<!-- <a-tabs type="card" v-model="klassId" @change="tabChange">
				<a-tab-pane v-for="klass in klassList" :key="klass.id" :tab="klass.name"></a-tab-pane>
			</a-tabs> -->

			<div class="assessment-content">
				<div class="p-bottom-20">
					<div class="m-bottom-20">
						<a-select class="width-160 m-right-20" v-model="klassId" placeholder="请选择班级" @change="tabChange" >
							<a-select-option v-for="item in klassList" :value="item.id" :key="item.id">
								{{ item.name }}
							</a-select-option>
						</a-select>
					</div>
					<a-select class="width-160 m-right-20" :class="{'assessment-archived-select': isArchived}" v-model="taskId" placeholder="请选择评估任务" @change="taskChange" >
						<a-select-option v-for="item in taskList" :value="item.id" :key="item.id">
							{{ item.title }}
						</a-select-option>
					</a-select>
					<!-- <span class="assessment-archived m-right-100" @click="viewArchivedTask">查看归档任务</span> -->

					<span class="del-color"><i class="assessment-dot"></i> 待评估 ({{ unAssesssmentNum }}) </span>
					<span class="warning-color"><i class="assessment-dot"></i> 评估中 ({{ assesssmentNum }}) </span>
					<span class="success-color"><i class="assessment-dot"></i> 已完成 ({{ completeNum }}) </span>
					<span class="primary-color"><i class="assessment-dot"></i> 已发送 ({{ sentNum }}) </span>
					<span class="info-color"><i class="assessment-dot"></i> 无需评估 ({{ skipNum }}) </span>

					<a-button v-if="!isManager && $route.name==='assessmentList'" ghost type="primary" class="fr"  @click="viewArchivedTask">查看归档任务</a-button>
				</div>
				<a-table :columns="columns" :data-source="tableSource" :rowKey="(record, index) => `${index}__${record.id}`" :pagination="false"
					bordered>
					<template slot="operation" slot-scope="text, record">

					</template>
					<template slot="operation" slot-scope="text, record">
						<div v-if="isArchived">
							<a v-if="record.id" class="assessment-table_btn primary-color m-right-20" href="javascript:;" @click="viewAssessment(record)">
								<svg-icon iconClass="eye"></svg-icon>
								<i class="assessment-table_btn_text">查看</i>
							</a>
						</div>

						<div class="assessment-table_btn" v-else-if="!record.id">
							<a class="assessment-table_btn m-right-20" href="javascript:;" @click="showCreateModal(record)">
								<svg-icon iconClass="plus"></svg-icon>
								<i class="assessment-table_btn_text">开始评估</i>
							</a>
							<a class="assessment-table_btn warning-color" href="javascript:;"
								@click="skipAssessmentHandle(record)">
								<svg-icon iconClass="giveup"></svg-icon>
								<i class="assessment-table_btn_text">无需评估</i>
							</a>
						</div>

						<div class="assessment-table_btn" v-else>
							<a v-if="['FINISHED', 'SENT'].includes(record.status)" class="assessment-table_btn primary-color m-right-20" href="javascript:;" @click="viewAssessment(record)">
								<svg-icon iconClass="eye"></svg-icon>
								<i class="assessment-table_btn_text">查看</i>
							</a>

							<a v-if="['INITIALIZED'].includes(record.status)" class="assessment-table_btn primary-color m-right-20" href="javascript:;" @click="viewAssessment(record)">
								<svg-icon iconClass="eye"></svg-icon>
								<i class="assessment-table_btn_text">继续评估</i>
							</a>

							<a class="assessment-table_btn primary-color" href="javascript:;"
								v-if="record.status === 'FINISHED'" @click="updateStatusHandle(record, 'SENT')">
								<svg-icon iconClass="publish"></svg-icon>
								<i class="assessment-table_btn_text">发送评估</i>
							</a>
							
							<a class="assessment-table_btn warning-color" href="javascript:;"
								v-if="record.status === 'SENT'" @click="updateStatusHandle(record, 'FINISHED')">
								<svg-icon iconClass="revoke"></svg-icon>
								<i class="assessment-table_btn_text">撤回评估</i>
							</a>

							<a v-if="record.status === 'SKIPPED'" class="assessment-table_btn primary-color" href="javascript:;"
								@click="showCreateModal(record)">
								<svg-icon iconClass="redo"></svg-icon>
								<i class="assessment-table_btn_text">重新评估</i>
							</a>

							<a v-if="['INITIALIZED'].includes(record.status)" class="assessment-table_btn del-color"
								href="javascript:;" @click="delHandle(record)">
								<svg-icon iconClass="delete"></svg-icon>
								<i class="assessment-table_btn_text">删除</i>
							</a>
						</div>
					</template>
				</a-table>
			</div>
		</a-spin>
		<a-modal :title="modalInfo.title" v-model="modalInfo.show">
			<div class="assessment-modal_item">
				<span class="assessment-modal_label">学生：</span>
				<span class="assessment-modal_value">{{ modalInfo.studentName }}</span>
			</div>
			<div class="assessment-modal_item">
				<span class="assessment-modal_label">班级：</span>
				<span class="assessment-modal_value">{{ modalInfo.klassName }}</span>
			</div>
			<div class="assessment-modal_item">
				<span class="assessment-modal_label">评估体系：</span>
				<span class="assessment-modal_value">幼儿五大领域评估</span>
			</div>
			<div class="assessment-modal_item">
				<span class="assessment-modal_label">评估模板：</span>
				<a-select class="assessment-modal_value" v-model="modalInfo.template_id" placeholder="请选择评估模板">
					<a-select-option v-for="item in temList" :value="item.id" :key="item.id">
						{{ item.title }}
					</a-select-option>
				</a-select>
			</div>
			<template slot="footer">
				<a-button @click="cancelHandle">取消</a-button>
				<!-- <a-button :loading="modalInfo.loading" type="primary" @click="createHandle()">确定</a-button> -->
				<a-button :loading="modalInfo.loading" type="primary" @click="createHandle('assessment')">开始评估</a-button>
			</template>
		</a-modal>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { getAssessmentColumns } from "./constant";
import AssessmentService from "@/api/assessmentService";
import StudentService from "@/api/studentService";
export default {
	name: "assessment",
	data() {
		return {
			columns: getAssessmentColumns(),
			tableSource: [],
			temList: [],
			klassId: undefined,
			taskId: undefined,
			taskList: [],
			klassTaskList: [],
			klassTaskId: undefined,
			loading: false,
			modalInfo: {
				show: false,
				loading: false,
				studentName: undefined,
				klassName: undefined,
				template_id: undefined,
			},
			unAssesssmentNum: 0,
			assesssmentNum: 0,
			completeNum: 0,
			sentNum: 0,
			skipNum: 0,
		};
	},

	computed: {
		...mapGetters(["schoolInfo", "curKlassId", "klassList", "isManager"]),
		isArchived () {
			return this.$route.name === "archivedAssessmentList";
		}
	},

	created() {
		this.klassId = this.$route.query.klass_id;
		this.taskId = this.$route.query.task_id;
		this.getTemplateList();
		this.getKlassList();
	},

	methods: {
		taskChange () {
			this.$router.replace({
				name: this.$route.name,
				query: { ...this.$route.query, task_id: this.taskId },
			});
			this.getKlassTaskList();
		},
		tabChange() {
			const klassTaskList = this.klassTaskList.filter((item) => {
				// if (!this.klassId) return true;
				return item.klass_id === this.klassId;
			}
			);

			if (!klassTaskList.length) {
				this.loading = false;
				return;
			}

			this.$router.replace({
				name: this.$route.name,
				query: { ...this.$route.query, klass_id: this.klassId },
			});

			this.klassTaskId = klassTaskList[0].id;
			this.getAssessmentListService();
		},

		getTemplateList() {
			AssessmentService.getTemplateListService().then((res = []) => {
				this.temList = res;
			});
		},

		getTaskList() {
			AssessmentService.getTaskListService({
				school_id: this.schoolInfo.id,
				status: this.$route.query.status || "ACTIVE",
			})
				.then((res = []) => {
					this.taskList = res.reverse();
					if (this.taskList.length) {
						this.taskId = this.taskId || this.taskList[0].id;
						if (!this.taskList.find(item => item.id === this.taskId)) {
							this.taskId = this.taskList[0].id;
						}
						this.taskChange();
					} else {
						this.loading = false;
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},

		getStudentList(originSource) {
			StudentService.getStudentListService({
				klass_id: this.klassId,
			}).then((res = []) => {
				this.loading = false;
				const tableSource = [];
				this.studentList = (res || []).filter((student) => {
					return (
						student.kinsfolk_info_from_teacher_list.filter(
							(item) => item.status === "ACCEPTED"
						).length > 0
					);
				});

				if (!this.studentList.length) {
					this.tableSource = [];
					return;
				}
				const studentIds = originSource.map((item) => item.student.id);

				this.studentList.forEach((student) => {
					if (!studentIds.includes(student.id)) {
						tableSource.push({ student });
					}
				});

				this.unAssesssmentNum = tableSource.length;
				this.tableSource = [...originSource, ...tableSource];
			});
		},

		getKlassTaskList() {
			this.loading = true;
			AssessmentService.getKlassTaskListService({
				task_id: this.taskId,
			})
				.then((res = []) => {
					this.klassTaskList = res;
					if (res.length) {
						this.tabChange();
					} else {
						this.loading = false;
						this.tableSource = [];
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},

		getKlassList(isForce = false) {
			this.loading = true;
			this.$store
				.dispatch("getKlassListService", { isForce })
				.then((res = []) => {
					this.klassId = this.klassId || this.curKlassId;
					if (!this.klassId && res.length) {
						this.klassId = res[0].id;
					}
					this.getTaskList();
				})
				.catch(() => {
					this.loading = false;
				});
		},

		getAssessmentListService() {
			this.loading = true;
			AssessmentService.getAssessmentListService({
				klass_task_id: this.klassTaskId,
			})
				.then((res = []) => {
					this.assesssmentNum = res.filter(
						(item) => item.status === "INITIALIZED"
					).length;
					this.completeNum = res.filter(
						(item) => item.status === "FINISHED"
					).length;
					this.sentNum = res.filter(
						(item) => item.status === "SENT"
					).length;
					this.skipNum = res.filter(
						(item) => item.status === "SKIPPED"
					).length;
					this.originSource = res;
					this.getStudentList(res);
				})
				.catch(() => {
					this.loading = false;
				});
		},

		showCreateModal(record) {
			const klassInfo = this.klassList.find(
				(item) => item.id === this.klassId
			);
			let template_id = undefined;
			if (this.originSource.length) {
				template_id = this.originSource[this.originSource.length - 1].template_id;
			}
			this.modalInfo = {
				title: record.id ? "重新评估" : "创建评估",
				id: record.id,
				show: true,
				loading: false,
				student_id: record.student.id,
				studentName: record.student.kid_name,
				klassName: klassInfo.name,
				template_id,
			};
		},

		cancelHandle() {
			this.modalInfo.show = false;
		},

		getTempInfo(type) {
			AssessmentService.getTemplateService({
				templateId: this.modalInfo.template_id,
			}).then((res) => {
				const items = [];
				const comments = [];
				res.top_categories.forEach((item) => {
					comments.push({
						content: "",
						category_id: item.id,
					});
					item.categories.forEach((catgory) => {
						catgory.items.forEach((option) => {
							items.push({
								option_id: option.id,
								score: undefined,
								is_skipped: false,
							});
						});
					});
				});

				this.createAssessment(type, items, comments);
			});
		},

		createHandle(type) {
			if (this.modalInfo.loading) return;
			if (!this.modalInfo.template_id) {
				this.$message.warning("请选择评估模板");
				return;
			}
			this.modalInfo.loading = true;
			this.getTempInfo(type);
		},

		async createAssessment(type, items, category_comments) {
			if (this.modalInfo.id) {
				await AssessmentService.delAssessmentService({
					assessmentId: this.modalInfo.id,
				});
			}

			const params = {
				student_id: this.modalInfo.student_id,
				template_id: this.modalInfo.template_id,
				klass_task_id: this.klassTaskId,
				items,
				category_comments,
				comment: "",
				status: "INITIALIZED",
			};

			AssessmentService.createAssessmentService(params)
				.then((res) => {
					this.$message.success("创建成功");
					if (type === "assessment") {
						this.$router.push({
							name: "assessment",
							query: {
								template_id: params.template_id,
								assessment_id: res.id,
							},
						});
					} else {
						this.modalInfo.show = false;
						this.getAssessmentListService();
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},

		delHandle(record) {
			this.$confirm({
				title: "提示信息",
				content: `是否删除 ${record.student.kid_name} 当前评估任务`,
				okText: "确定",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						AssessmentService.delAssessmentService({
							assessmentId: record.id,
						})
							.then(() => {
								this.$message.success("删除成功");
								this.getAssessmentListService();
								resolve();
							})
							.catch((err) => {
								this.$message.error("操作失败，请检查后重试");
								reject(err);
							});
					});
				},
			});
		},

		updateStatusHandle(record, status) {
			let tips = "是否继续对当前评估任务的操作";
			switch (status) {
				case "FINISHED":
					tips = `确认撤回${record.student.kid_name}的评估报告？`
					break;
				case "SENT":
					tips = `是否确认发送当前报告给家长？`
					break;
			}
			this.$confirm({
				title: "提示信息",
				content: tips,
				okText: "确定",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						AssessmentService.updateAssessmentStatusService({
							assessmentId: record.id,
							status,
						})
							.then(() => {
								this.$message.success("操作成功");
								this.getAssessmentListService();
								resolve();
							})
							.catch((err) => {
								this.$message.error("操作失败，请检查后重试");
								reject(err);
							});
					});
				},
			});
		},

		skipAssessmentHandle(record) {
			const params = {
				student_id: record.student.id,
				template_id: this.temList[0].id,
				klass_task_id: this.klassTaskId,
				items: [],
				category_comments: [],
				comment: "",
				status: "SKIPPED",
			};

			AssessmentService.createAssessmentService(params)
				.then(() => {
					this.$message.success("操作成功");
					this.getAssessmentListService();
				})
				.catch(() => {
					this.loading = false;
				});
		},

		viewAssessment(record) {
			this.$router.push({
				name: "assessment",
				query: {
					template_id: record.template_id,
					assessment_id: record.id,
				},
			});
		},

		viewArchivedTask () {
			this.$router.push({ name: "archivedTask" })
		}
	},
};
</script>

<style lang="less" scoped>
.assessment {
	&-container {
		background: #ffffff;
		min-height: calc(100% - 65px);
		margin-top: 15px;

		/deep/.ant-tabs-nav-scroll {
			background: #f0f2f5;
		}

		/deep/.ant-tabs-tab {
			border: none !important;
			margin: 0 !important;
		}

		/deep/.ant-tabs-bar {
			margin-bottom: 0;
		}
	}

	&-archived-select {
		/deep/.ant-select-selection {
			border-color: #FFA647;
		}
	}

	&-content {
		padding: 28px 28px 2px 30px;
	}

	&-table {
		&_btn {
			display: flex;
			flex-flow: nowrap row;
			align-items: center;
			justify-content: center;
			line-height: 1;

			&_text {
				margin-left: 5px;
				line-height: 1;
			}

			&_disabled {
				cursor: not-allowed;
				color: rgba(0, 0, 0, 0.25);
				border-color: #d9d9d9;
			}
		}
	}

	&-modal {
		&_item {
			display: flex;
			flex-flow: nowrap row;
			align-items: center;
			margin-bottom: 10px;
			padding-left: 50px;
		}

		&_label {
			width: 100px;
		}

		&_value {
			width: 300px;
			text-align: left;
		}
	}

	&-dot {
		display: inline-block;
		width: 10px;
		height: 10px;
		margin: 0 12px 0 24px;
		border-radius: 50%;
	}

	&-archived {
		text-decoration: underline;
		color: #1890ff;
		cursor: pointer;
	}
}
.info-color .assessment-dot {
	background-color: #999;
}
.warning-color .assessment-dot {
	background-color: #FFA647;
}
.success-color .assessment-dot {
	background-color: #1AB752;
}
.primary-color .assessment-dot {
	background-color: #1890ff;
}
.del-color .assessment-dot {
	background-color: #FE5C73;
}
</style>
